<template>
  <div class="check-setting-module-root">
    <ba-header activeModule="Check Setting" disable-menu="true"></ba-header>
    <div class="u-p4 main-content">

      <h2 class="u-mt2 c-heading__page">Check Setting</h2>
      <p class="u-mt2">See a setting's value for every company at once, without switching from one company to another.</p>

      <form class="u-mt3 check-setting-form" @submit.prevent="loadValues">
        <el-input v-model="settingSlug" placeholder="section.slug, e.g. payments.payment_disallowed_statuses"
                  clearable></el-input>
        <el-button type="primary" native-type="submit" :disabled="!trimmedSlug" :loading="loading">Show</el-button>
      </form>

      <div v-if="result" class="u-mt4" v-loading="loading">
        <h3>{{ loadedSlug }}</h3>
        <p class="u-mt2">Base value: <code>{{ displayValue(result.setting_original_value) }}</code></p>

        <el-table class="u-mt3" :data="result.companies_values"
                  :default-sort="{prop: 'company_name', order: 'ascending'}">
          <el-table-column prop="company_name" label="Company Name" sortable></el-table-column>
          <el-table-column prop="value" label="Setting Value" sortable :sort-method="sortByDisplayedValue">
            <template slot-scope="scope">
              <code>{{ displayValue(scope.row.value) }}</code>
            </template>
          </el-table-column>
          <el-table-column prop="overridden" label="Is Overridden" sortable>
            <template slot-scope="scope">
              {{ scope.row.overridden ? 'Yes' : 'No' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import config from '@/config'

  export default {
    name: 'baCheckSettingPage',
    data () {
      return {
        settingSlug: '',
        loadedSlug: '',
        result: null,
        loading: false
      }
    },
    computed: {
      trimmedSlug () {
        return this.settingSlug.trim()
      }
    },
    methods: {
      displayValue (value) {
        if (value === null || value === undefined) {
          return ''
        }
        return typeof value === 'object' ? JSON.stringify(value) : String(value)
      },
      sortByDisplayedValue (a, b) {
        return this.displayValue(a.value).localeCompare(this.displayValue(b.value), undefined, {numeric: true})
      },
      loadValues () {
        let slug = this.trimmedSlug
        if (!slug) {
          return
        }
        this.loading = true
        axios.get(`${config.url}/settings/${encodeURIComponent(slug)}/companies/`)
          .then(response => {
            this.result = response.data
            this.loadedSlug = slug
            this.loading = false
          })
          .catch(e => {
            this.loading = false
            this.result = null
            let message = e.response && e.response.data && e.response.data.message
            this.$notify.error({
              title: 'Error',
              message: message || 'Failed to load setting values',
            })
          })
      }
    }
  }
</script>

<style scoped>
  .check-setting-form {
    display: flex;
    gap: 8px;
    max-width: 640px;
  }
</style>
